export default "__VITE_ASSET__CAkoBTxi__"